"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const endpoints = __importStar(require("./types/endpoints"));
const utils_1 = require("./utils");
const HttpClient_1 = require("./HttpClient");
/**
 * EOSIO Client
 *
 * @name EosioClient
 * @param {string} endpoint dsp endpoint
 * @param {object} [options={}] optional params
 * @param {Fetch} [options.fetch=global.fetch] fetch
 * @example
 *
 * const endpoint = "https://api.eosn.io"
 * const client = new EosioClient(endpoint, { fetch })
 */
class EosioClient extends HttpClient_1.HttpClient {
    constructor(endpoint, options = {}) {
        super(endpoint, options);
    }
    /**
     * [GET /v1/chain/get_table_rows](https://developers.eos.io/eosio-nodeos/reference#get_table_rows)
     *
     * Returns an object containing rows from the specified table.
     *
     * @param {string} code The name of the smart contract that controls the provided table
     * @param {string} scope The account to which this data belongs
     * @param {string} table The name of the table to query
     * @param {object} [options={}] optional params
     * @param {string} [options.lower_bound] Filters results to return the first element that is not less than provided value in set
     * @param {string} [options.upper_bound] Filters results to return the first element that is greater than provided value in set
     * @param {number} [options.limit=10] Limit the result amount
     * @param {boolean} [options.show_payer=false] Show Payer
     * @param {boolean} [options.json=true] JSON response
     * @param {number} [options.index_position=1] Position of the index used
     * @param {string} [options.key_type] Type of key specified by index_position (for example - uint64_t or name)
     * @param {string} [options.table_key] Table Key
     * @param {string} [options.encode_type] Encode type
     * @returns {Promise<GetTableRows>} table rows
     * @example
     *
     * const response = await rpc.get_table_rows("<code>", "<scope>", "<table>");
     * console.log(response);
     */
    get_table_rows(code, scope, table, options = {}) {
        // Optional params
        const json = options.json === false ? false : true;
        const index_position = options.index_position || 1;
        const limit = options.limit || 10;
        const key_type = options.key_type || "";
        const table_key = options.table_key || "";
        const lower_bound = options.lower_bound || "";
        const upper_bound = options.upper_bound || "";
        const encode_type = options.encode_type || "";
        const show_payer = options.show_payer === true ? true : false;
        return this.post(endpoints.V1_GET_TABLE_ROWS, {
            code,
            table,
            scope,
            json,
            index_position,
            key_type,
            table_key,
            lower_bound,
            upper_bound,
            encode_type,
            show_payer,
            limit,
        });
    }
    /**
     * [GET /v1/chain/get_table_rows](https://developers.eos.io/eosio-nodeos/reference#get_table_rows)
     *
     * Returns all objects containing rows from the specified table.
     *
     * @param {string} code The name of the smart contract that controls the provided table
     * @param {string} scope The account to which this data belongs
     * @param {string} table The name of the table to query
     * @param {string} lower_bound_key Key value to identify `lower_bound` object
     * @param {object} [options={}] optional params
     * @param {string} [options.lower_bound] Filters results to return the first element that is not less than provided value in set
     * @param {string} [options.upper_bound] Filters results to return the first element that is greater than provided value in set
     * @param {number} [options.limit=1500] Limit the result amount per `get_table_rows` API request
     * @param {boolean} [options.show_payer=false] Show Payer
     * @param {boolean} [options.json=true] JSON response
     * @param {number} [options.index_position=1] Position of the index used
     * @param {string} [options.key_type] Type of key specified by index_position (for example - uint64_t or name)
     * @param {string} [options.table_key] Table Key
     * @param {string} [options.encode_type] Encode type
     * @param {number} [options.delay_ms] Delay in ms between API calls (helps prevents rate limited APIs)
     * @returns {Promise<GetTableRows>} table rows
     * @example
     *
     * const response = await rpc.get_all_table_rows("<code>", "<scope>", "<table>", "<lower_bound_key>");
     * console.log(response);
     */
    get_all_table_rows(code, scope, table, lower_bound_key, options = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            // Optional params from `get_table_rows`
            const json = options.json === false ? false : true;
            const index_position = options.index_position || 1;
            const limit = options.limit || 1500;
            const key_type = options.key_type || "";
            const table_key = options.table_key || "";
            const upper_bound = options.upper_bound || "";
            const encode_type = options.encode_type || "";
            const show_payer = options.show_payer === true ? true : false;
            // Delay in ms between API calls (helps prevents rate limited APIs)
            const delay_ms = options.delay_ms || 10;
            // Track latest used `lower_bound` unique identifier key
            let lower_bound = options.lower_bound || "";
            // Data container
            const rows = new Map();
            while (true) {
                const response = yield this.get_table_rows(code, scope, table, {
                    json,
                    index_position,
                    limit,
                    key_type,
                    table_key,
                    lower_bound,
                    upper_bound,
                    encode_type,
                    show_payer,
                });
                for (const row of response.rows) {
                    // Adding to Map removes duplicates entries
                    const key = row[lower_bound_key];
                    rows.set(key, row);
                    // Set lower bound
                    lower_bound = key;
                }
                // prevent hitting rate limits from API endpoints
                yield utils_1.delay(delay_ms);
                // end of table rows
                if (response.more === false) {
                    break;
                }
            }
            return {
                more: false,
                rows: Array.from(rows.values()),
            };
        });
    }
    /**
     * [GET /v1/chain/get_table_by_scope](https://developers.eos.io/eosio-nodeos/reference#get_table_by_scope)
     *
     * Returns an object containing rows from the specified table.
     *
     * @param {string} code name of the contract to return table data for
     * @param {object} [options={}] optional params
     * @param {string} [options.table] Filter results by table
     * @param {string} [options.lower_bound] Filters results to return the first element that is not less than provided value in set
     * @param {string} [options.upper_bound] Filters results to return the first element that is greater than provided value in set
     * @param {number} [options.limit] Limit number of results returned.
     * @param {boolean} [options.reverse=false] Reverse the order of returned results
     * @returns {Promise<GetTableByScope>} table rows
     * @example
     *
     * const response = await rpc.get_table_by_scope();
     * console.log(response);
     */
    get_table_by_scope(code, options = {}) {
        // Optional params
        const limit = options.limit || 10;
        const lower_bound = options.lower_bound || "";
        const upper_bound = options.upper_bound || "";
        const table = options.table || "";
        const reverse = options.reverse === true ? true : false;
        return this.post(endpoints.V1_GET_TABLE_BY_SCOPE, {
            code,
            table,
            lower_bound,
            upper_bound,
            limit,
            reverse,
        });
    }
    /**
     * [GET /v1/chain/get_currency_balance](https://developers.eos.io/eosio-nodeos/reference#get_currency_balance)
     *
     * Retrieve the stats of for a given currency
     *
     * @param {string} code The contract that operates the currency
     * @param {string} account The account to query balances for
     * @param {string} symbol The symbol for the currency if the contract operates multiple currencies
     * @returns {Promise<GetCurrencyBalance>} table rows
     * @example
     *
     * const response = await rpc.get_currency_balance("eosio.token", "eosio.null", "EOS");
     * console.log(response);
     */
    get_currency_balance(code, account, symbol) {
        return this.post(endpoints.V1_GET_CURRENCY_BALANCE, {
            code,
            account,
            symbol,
        });
    }
    /**
     * [GET /v1/chain/get_currency_stats](https://developers.eos.io/eosio-nodeos/reference#get_currency_stats)
     *
     * Retrieve the stats of for a given currency
     *
     * @param {string} code The contract that operates the currency
     * @param {string} symbol The symbol for the currency if the contract operates multiple currencies
     * @returns {Promise<GetCurrencyStats>} table rows
     * @example
     *
     * const response = await rpc.get_currency_stats("eosio.token", "EOS");
     * console.log(response);
     */
    get_currency_stats(code, symbol) {
        return this.post(endpoints.V1_GET_CURRENCY_STATS, {
            code,
            symbol,
        });
    }
    /**
     * [GET /v1/chain/get_info](https://developers.eos.io/eosio-nodeos/reference#get_info)
     *
     * Returns an object containing various details about the blockchain.
     *
     * @returns {Promise<GetInfo>} table rows
     * @example
     *
     * const response = await rpc.get_info();
     * console.log(response);
     */
    get_info() {
        return this.post(endpoints.V1_GET_INFO);
    }
}
exports.EosioClient = EosioClient;
//# sourceMappingURL=EosioClient.js.map